export default __webpack_public_path__ + "static/media/Cadaverous Bite.17ec4134.jpg";